import React from "react";

const ChannelLogo: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={55}
    height={55}
    viewBox="0 0 55 55"
    fill="none"
    {...props}
  >
    <path
      d="M48.125 48.125l-8.02-8.02m5.728-13.75c0 10.757-8.72 19.478-19.479 19.478-10.758 0-19.479-8.72-19.479-19.479 0-10.758 8.721-19.479 19.48-19.479 10.757 0 19.478 8.721 19.478 19.48z"
      stroke="#8065C9"
      strokeWidth={3.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChannelLogo;
